import React, { useState } from 'react';
import { Tooltip } from 'shards-react';
import shortid from 'shortid';

function CRBadge({ newValue, placement = 'top' }) {
  const [open, setOpen] = useState(false);
  const [id] = useState('cr-' + shortid.generate());

  return (
    <>
      <span
        id={id}
        className="cr-badge mx-1"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        CR
      </span>
      <Tooltip
        open={open}
        placement={placement}
        target={'#' + id}
        toggle={() => setOpen(!open)}
      >
        {newValue != null ? String(newValue) : '-'}
      </Tooltip>
    </>
  );
}

export default CRBadge;
